import React, { useEffect } from "react";
import StickyList from "../../component/global/stickyList";
import SearchFooter from "../../component/content/searchJobFooter";
import { useDrawerTransition } from "../../context/drawerProvider";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import { useParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";

const HireProgress = ({ }) => {
    const { startTransition } = useDrawerTransition();
    const { lang } = useSelector((state) => state.globalReducer);

    const dispatch = useDispatch();
    const { language } = useParams();

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const hireStep = [
        {
            label: Lang(lang, 'hire_step1_title'),
            desc: Lang(lang, 'hire_step1_desc'),
            img: '/asset/Apply.webp',
        },
        {
            label: Lang(lang, 'hire_step2_title'),
            desc: Lang(lang, 'hire_step2_desc'),
            img: '/asset/screening.webp',
        },
        {
            label: Lang(lang, 'hire_step3_title'),
            desc: Lang(lang, 'hire_step3_desc'),
            img: '/asset/PsychoTest.webp',
        },
        {
            label: Lang(lang, 'hire_step4_title'),
            desc: Lang(lang, 'hire_step4_desc'),
            img: '/asset/ChatHR.webp',
        },
        {
            label: Lang(lang, 'hire_step5_title'),
            desc: Lang(lang, 'hire_step5_desc'),
            img: '/asset/TestSkill.webp',
        },
        {
            label: Lang(lang, 'hire_step6_title'),
            desc: Lang(lang, 'hire_step6_desc'),
            img: '/asset/Last.webp',
        }
    ];

    return (<div className="">
        <div className="pt-8">
            <p className='text-[#48494B] text-[32px] md:text-[84px] font-normal leading-tight text-center'>{lang === 'en' && 'Your'} <b className='text-[#034694] font-semibold'>{lang === 'en' ? 'next chapter' : 'Langkah baru'}</b> {lang === 'en' ? 'starts here' : 'Anda dimulai disini'}</p>
            <div className="my-5" />
            <p className="text-[#48494B] text-[13px] md:text-[25px] font-normal leading-tight text-center w-[80%] md:w-[60%] mx-auto">{Lang(lang, 'hire_title_desc')}</p>
        </div>

        <div className="w-[80%] md:w-[72%] mx-auto pt-10 md:pt-20 max-w-[1180px]">
            <div className="relative flex flex-col justify-center gap-10">
                <StickyList data={hireStep} />
            </div>
        </div>

        <SearchFooter />
    </div>)
}

export default HireProgress;